/**
 * Assets del producto DPS47 · Vivencia Ready.
 *
 * MAIN_MOCKUP_URL: mockup principal (hero y recuadro de precio). Vacío = se
 * dibujan las seis portadas de volumen con CSS.
 */
export const MAIN_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/qe3sUKRHN12WVVa5ScXvr9/Viviencia-Photorealistic-product-mockup-3-2-horiz.png'
